export default function TS_Enums() {
  return (
    <div>
      <h1>TS Enums</h1>
      <p>This is the TS Enums page.</p>
    </div>
  );
}